"use strict";

var _classCallCheck = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/www/rememberme/admin/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodashEs = require("lodash-es");

var _recommendedKeywordCount = require("../../assessmentHelpers/recommendedKeywordCount.js");

var _recommendedKeywordCount2 = _interopRequireDefault(_recommendedKeywordCount);

var _assessment = require("../../assessment");

var _assessment2 = _interopRequireDefault(_assessment);

var _getLanguage = require("../../helpers/getLanguage");

var _getLanguage2 = _interopRequireDefault(_getLanguage);

var _getLanguagesWithWordFormSupport = require("../../helpers/getLanguagesWithWordFormSupport");

var _getLanguagesWithWordFormSupport2 = _interopRequireDefault(_getLanguagesWithWordFormSupport);

var _AssessmentResult = require("../../values/AssessmentResult");

var _AssessmentResult2 = _interopRequireDefault(_AssessmentResult);

var _inRange = require("../../helpers/inRange");

var _shortlinker = require("../../helpers/shortlinker");

var _keyphraseLengthFactor = require("../../helpers/keyphraseLengthFactor.js");

var _keyphraseLengthFactor2 = _interopRequireDefault(_keyphraseLengthFactor);

var _countWords = require("../../stringProcessing/countWords");

var _countWords2 = _interopRequireDefault(_countWords);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Represents the assessment that will look if the keyphrase density is within the recommended range.
 */


var KeywordDensityAssessment = /*#__PURE__*/function (_assessment2$default) {
  _inherits(KeywordDensityAssessment, _assessment2$default);

  /**
   * Sets the identifier and the config.
   *
   * @param {Object} [config] The configuration to use.
   *
   * If word forms are not available:
   * @param {number} [config.parameters.noWordForms.overMaximum] The percentage of keyphrase instances in the text that
   * is way over the maximum.
   * @param {number} [config.parameters.noWordForms.maximum] The maximum percentage of keyphrase instances in the text.
   * @param {number} [config.parameters.noWordForms.minimum] The minimum percentage of keyphrase instances in the text.
   *
   * If word forms are available:
   * @param {number} [config.parameters.multipleWordForms.overMaximum] The percentage of keyphrase instances in the text that
   * is way over the maximum.
   * @param {number} [config.parameters.multipleWordForms.maximum] The maximum percentage of keyphrase instances in the text.
   * @param {number} [config.parameters.multipleWordForms.minimum] The minimum percentage of keyphrase instances in the text.
   *
   * @param {number} [config.scores.wayOverMaximum] The score to return if there are way too many instances of keyphrase in the text.
   * @param {number} [config.scores.overMaximum] The score to return if there are too many instances of keyphrase in the text.
   * @param {number} [config.scores.correctDensity] The score to return if there is a good number of keyphrase instances in the text.
   * @param {number} [config.scores.underMinimum] The score to return if there is not enough keyphrase instances in the text.
   *
   * @param {string} [config.url] The URL to the relevant KB article.
   *
   * @returns {void}
   */
  function KeywordDensityAssessment() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, KeywordDensityAssessment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeywordDensityAssessment).call(this));
    var defaultConfig = {
      parameters: {
        noWordForms: {
          overMaximum: 4,
          maximum: 3,
          minimum: 0.5
        },
        multipleWordForms: {
          overMaximum: 4,
          maximum: 3.5,
          minimum: 0.5
        }
      },
      scores: {
        wayOverMaximum: -50,
        overMaximum: -10,
        correctDensity: 9,
        underMinimum: 4
      },
      urlTitle: (0, _shortlinker.createAnchorOpeningTag)("https://yoa.st/33v"),
      urlCallToAction: (0, _shortlinker.createAnchorOpeningTag)("https://yoa.st/33w")
    };
    _this.identifier = "keywordDensity";
    _this._config = (0, _lodashEs.merge)(defaultConfig, config);
    return _this;
  }
  /**
   * Determines correct boundaries depending on the availability
   * of morphological forms.
   *
   * @param {string} text The paper text.
   * @param {number} keyphraseLength The length of the keyphrase in words.
   *
   * @returns {void}
   */


  _createClass(KeywordDensityAssessment, [{
    key: "setBoundaries",
    value: function setBoundaries(text, keyphraseLength) {
      if (this._hasMorphologicalForms) {
        this._boundaries = this._config.parameters.multipleWordForms;
      } else {
        this._boundaries = this._config.parameters.noWordForms;
      }

      this._minRecommendedKeywordCount = (0, _recommendedKeywordCount2.default)(text, keyphraseLength, this._boundaries.minimum, "min");
      this._maxRecommendedKeywordCount = (0, _recommendedKeywordCount2.default)(text, keyphraseLength, this._boundaries.maximum, "max");
    }
    /**
     * Runs the keyphrase density module, based on this returns an assessment
     * result with score.
     *
     * @param {Paper} paper The paper to use for the assessment.
     * @param {Researcher} researcher The researcher used for calling the
     *                                research.
     * @param {Jed} i18n The object used for translations.
     *
     * @returns {AssessmentResult} The result of the assessment.
     */

  }, {
    key: "getResult",
    value: function getResult(paper, researcher, i18n) {
      this._hasMorphologicalForms = researcher.getData("morphology") !== false && (0, _getLanguagesWithWordFormSupport2.default)().includes((0, _getLanguage2.default)(paper.getLocale()));
      this._keywordCount = researcher.getResearch("keywordCount");
      var keyphraseLength = this._keywordCount.length;
      this.setBoundaries(paper.getText(), keyphraseLength);
      var assessmentResult = new _AssessmentResult2.default();
      this._keywordDensity = researcher.getResearch("getKeywordDensity");
      this._keywordDensity = this._keywordDensity * (0, _keyphraseLengthFactor2.default)(keyphraseLength);
      var calculatedScore = this.calculateResult(i18n);
      assessmentResult.setScore(calculatedScore.score);
      assessmentResult.setText(calculatedScore.resultText);
      assessmentResult.setHasMarks(this._keywordCount.count > 0);
      return assessmentResult;
    }
    /**
     * Checks whether there are no keyphrase matches in the text.
     *
     * @returns {boolean} Returns true if the keyphrase count is 0.
     */

  }, {
    key: "hasNoMatches",
    value: function hasNoMatches() {
      return this._keywordCount.count === 0;
    }
    /**
     * Checks whether there are too few keyphrase matches in the text.
     *
     * @returns {boolean} Returns true if the rounded keyword density is between 0 and the recommended minimum
     * or if there there is only 1 keyword match (regardless of the density).
     */

  }, {
    key: "hasTooFewMatches",
    value: function hasTooFewMatches() {
      return (0, _inRange.inRangeStartInclusive)(this._keywordDensity, 0, this._boundaries.minimum) || this._keywordCount.count === 1;
    }
    /**
     * Checks whether there is a good number of keyphrase matches in the text.
     *
     * @returns {boolean} Returns true if the rounded keyword density is between the recommended minimum
     * and the recommended maximum or if the keyword count is 2 and the recommended minimum is lower than 2.
     */

  }, {
    key: "hasGoodNumberOfMatches",
    value: function hasGoodNumberOfMatches() {
      return (0, _inRange.inRangeStartEndInclusive)(this._keywordDensity, this._boundaries.minimum, this._boundaries.maximum) || this._keywordCount.count === 2 && this._minRecommendedKeywordCount <= 2;
    }
    /**
     * Checks whether the number of keyphrase matches in the text is between the
     * recommended maximum and the specified overMaximum value.
     *
     * @returns {boolean} Returns true if the rounded keyphrase density is between
     *                    the recommended maximum and the specified overMaximum
     *                    value.
     */

  }, {
    key: "hasTooManyMatches",
    value: function hasTooManyMatches() {
      return (0, _inRange.inRangeEndInclusive)(this._keywordDensity, this._boundaries.maximum, this._boundaries.overMaximum);
    }
    /**
     * Returns the score for the keyphrase density.
     *
     * @param {Jed} i18n The object used for translations.
     *
     * @returns {Object} The object with calculated score and resultText.
     */

  }, {
    key: "calculateResult",
    value: function calculateResult(i18n) {
      if (this.hasNoMatches()) {
        return {
          score: this._config.scores.underMinimum,
          resultText: i18n.sprintf(
          /* Translators:
          %1$s and %4$s expand to links to Yoast.com,
          %2$s expands to the anchor end tag,
          %3$d expands to the recommended minimal number of times the keyphrase should occur in the text. */
          i18n.dgettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found 0 times. " + "That's less than the recommended minimum of %3$d times for a text of this length. " + "%4$sFocus on your keyphrase%2$s!"), this._config.urlTitle, "</a>", this._minRecommendedKeywordCount, this._config.urlCallToAction)
        };
      }

      if (this.hasTooFewMatches()) {
        return {
          score: this._config.scores.underMinimum,
          resultText: i18n.sprintf(
          /* Translators:
          %1$s and %4$s expand to links to Yoast.com,
          %2$s expands to the anchor end tag,
          %3$d expands to the recommended minimal number of times the keyphrase should occur in the text,
          %5$d expands to the number of times the keyphrase occurred in the text. */
          i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d time. That's less than the " + "recommended minimum of %3$d times for a text of this length. %4$sFocus on your keyphrase%2$s!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d times. That's less than the " + "recommended minimum of %3$d times for a text of this length. %4$sFocus on your keyphrase%2$s!", this._keywordCount.count), this._config.urlTitle, "</a>", this._minRecommendedKeywordCount, this._config.urlCallToAction, this._keywordCount.count)
        };
      }

      if (this.hasGoodNumberOfMatches()) {
        return {
          score: this._config.scores.correctDensity,
          resultText: i18n.sprintf(
          /* Translators:
          %1$s expands to a link to Yoast.com,
          %2$s expands to the anchor end tag,
          %3$d expands to the number of times the keyphrase occurred in the text. */
          i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %3$d time. This is great!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %3$d times. This is great!", this._keywordCount.count), this._config.urlTitle, "</a>", this._keywordCount.count)
        };
      }

      if (this.hasTooManyMatches()) {
        return {
          score: this._config.scores.overMaximum,
          resultText: i18n.sprintf(
          /* Translators:
          %1$s and %4$s expand to links to Yoast.com,
          %2$s expands to the anchor end tag,
          %3$d expands to the recommended maximal number of times the keyphrase should occur in the text,
          %5$d expands to the number of times the keyphrase occurred in the text. */
          i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d time. That's more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d times. That's more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", this._keywordCount.count), this._config.urlTitle, "</a>", this._maxRecommendedKeywordCount, this._config.urlCallToAction, this._keywordCount.count)
        };
      } // Implicitly returns this if the rounded keyphrase density is higher than overMaximum.


      return {
        score: this._config.scores.wayOverMaximum,
        resultText: i18n.sprintf(
        /* Translators:
        %1$s and %4$s expand to links to Yoast.com,
        %2$s expands to the anchor end tag,
        %3$d expands to the recommended maximal number of times the keyphrase should occur in the text,
        %5$d expands to the number of times the keyphrase occurred in the text. */
        i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d time. That's way more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d times. That's way more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", this._keywordCount.count), this._config.urlTitle, "</a>", this._maxRecommendedKeywordCount, this._config.urlCallToAction, this._keywordCount.count)
      };
    }
    /**
     * Marks keywords in the text for the keyword density assessment.
     *
     * @returns {Array<Mark>} Marks that should be applied.
     */

  }, {
    key: "getMarks",
    value: function getMarks() {
      return this._keywordCount.markings;
    }
    /**
     * Checks whether the paper has a text with at least 100 words and a keyword
     * is set.
     *
     * @param {Paper} paper The paper to use for the assessment.
     *
     * @returns {boolean} True if applicable.
     */

  }, {
    key: "isApplicable",
    value: function isApplicable(paper) {
      return paper.hasText() && paper.hasKeyword() && (0, _countWords2.default)(paper.getText()) >= 100;
    }
  }]);

  return KeywordDensityAssessment;
}(_assessment2.default);

exports.default = KeywordDensityAssessment;